import React from 'react'
import { useStyles, Flex, FormControl, FormLabel, FormHelperText } from '@chakra-ui/react'

import { useFieldListItem } from './useFieldList'

export const FieldListItem = ({ id, label, helperText, children, isRequired, ...props }) => {
  const styles = useStyles()
  const { isLoading } = useFieldListItem()

  return (
    <FormControl as={Flex} sx={styles.FieldListItem} id={id} isRequired={isRequired}>
      {label && (
        <FormLabel sx={styles.FieldListItemLabel} htmlFor={id}>
          {label}
        </FormLabel>
      )}
      <Flex sx={styles.FieldListItemField}>
        {React.cloneElement(children, { id, isRequired, isLoading })}
      </Flex>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export default FieldListItem
